import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { filter, throttleTime } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { NavigationEnd, Router } from "@angular/router";
import { CamerallaAuthService } from "./shared/services/authentication-services/cameralla-auth.service";
import { environment } from "../environments/environment";

declare var gtag;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  public static eventOnImageError;

  constructor(
    private toastr: ToastrService,
    public router: Router,
    protected authService: CamerallaAuthService
  ) {
    // if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !/AppleWebKit(.*)(?=Crios)(.*)/igm.test(navigator.userAgent)) {
    //     _swal.fire({
    //         title: 'Welcome to Cameralla',
    //         text: "We recommend Chrome for the best experience",
    //         type: 'warning',
    //         showCancelButton: true,
    //         showConfirmButton: false,
    //         cancelButtonColor: '#ffa300',
    //         cancelButtonText: 'Continue',
    //     })
    // }

    AppComponent.eventOnImageError = new Subject();
    AppComponent.eventOnImageError
      .pipe(throttleTime(6000))
      .subscribe((value) => {
        this.toastr.warning(
          "Oops.. Too slow internet connection or switch to Chrome browser for the best experience.",
          "Warning",
          { timeOut: 5000 }
        );
      });

    if (environment.production) {
      const navEndEvent$ = router.events.pipe(
        filter((e) => e instanceof NavigationEnd)
      );
      navEndEvent$.subscribe((e: NavigationEnd) => {
        gtag("config", environment.googleAnalyticsId, {
          page_path: "/club" + e.urlAfterRedirects,
          user_id: "user" + this.authService.getLocalUserInfo()["id"] + 69, // mask userId
          page_title:
            e.urlAfterRedirects == "/" ? "Share page" : e.urlAfterRedirects,
          page_location: "/club" + e.urlAfterRedirects,
        });
      });
    }
  }

  ngOnInit() {
    if (!environment.production) {
      console.log("app component sv, update alpha");
    }
  }
}
